// @ts-check
// Planilha CSV para o Excel em pt-BR: separador ";", UTF-8 com BOM (sem ele o Excel lê os acentos errado).
import { neutralizeCsvFormula } from '../../../shared/csv/neutralize-csv-formula.js';

const CSV_SEPARATOR = ';';
const BYTE_ORDER_MARK = '﻿';

/**
 * @param {unknown} value
 */
export function escapeCell(value) {
  if (value === null || value === undefined) return '';
  // números (contagens, somas) saem como número; texto que parece fórmula ganha apóstrofo
  const text = typeof value === 'number' ? String(value) : neutralizeCsvFormula(String(value));
  return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * @param {unknown[][]} rows primeira linha = cabeçalho
 */
export function buildCsv(rows) {
  return BYTE_ORDER_MARK + rows.map((row) => row.map(escapeCell).join(CSV_SEPARATOR)).join('\r\n');
}

/**
 * Número no formato do Excel pt-BR (vírgula decimal, sem separador de milhar), para continuar somável na planilha.
 * @param {number | null | undefined} value
 */
export function formatCsvNumber(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '';
  const rounded = Math.round(Number(value) * 100) / 100;
  return String(rounded).replace('.', ',');
}

/**
 * @param {Blob} blob
 * @param {string} fileName
 */
export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Alguns navegadores ainda leem o blob depois do clique.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * @param {string} text
 * @param {string} fileName
 */
export function downloadCsv(text, fileName) {
  downloadBlob(new Blob([text], { type: 'text/csv;charset=utf-8' }), fileName);
}

/**
 * Nome de arquivo seguro a partir de um título (sem acentos, barras ou espaços).
 * @param {string} title
 * @param {string} [extension]
 */
export function toFileName(title, extension = 'csv') {
  const base = String(title || 'export')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^\w-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
  const today = new Date();
  const stamp = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  return `${base || 'export'}-${stamp}.${extension}`;
}
